<template lang="pug">
extends ../../../prototype/src/pug/layout/section_column_gray_top
include ../../../prototype/src/pug/abstracts/mixin.pug
block main
	.duvidas_frequentes__wrapper
		h1.duvidas_frequentes__title Perguntas Frequentes Sobre Certificado Digital

		p.duvidas_frequentes__description Para facilitar sua pesquisa e esclarecer suas dúvidas de forma mais eficaz e rápida, separamos abaixo algumas das principais dúvidas levantadas pelos nossos consumidores:

		div('v-for'="item in questions")
			h2.duvidas_frequentes__subtitle('v-html'="item.topic", :id="normalize(item.topic)") xxx
			.duvidas_frequentes__questions
				QuestionRow('v-for'="subitem in item.data" :question="subitem.question" :answer="subitem.answer" :download="subitem.download" :view="subitem.view" :files="subitem.files" :download_2="subitem.download_2")
block variables
	- var id = 'faq'
</template>

<script>
import data from "@/assets/faq.json";
import QuestionRow from "@/components/duvidas_frequentes/question_row.vue";

export default {
	name: "Faq",
	components: {
		QuestionRow
	},
	data: function() {
		return {
			questions: data
		};
	},
	metaInfo: {
		title: 'Perguntas Frequentes Sobre Certificado Digital - SPC Brasil',
		meta: [
			{ description: 'Tire todas as suas dúvidas sobre o uso e a instalação de um certificado digital - tanto eCPF quanto eCNPJ. Acesse agora!' }
		]
	},
	methods: {
		normalize: function(text) {
			return text.toLowerCase().replace(/ /gi, '-').replace(/&/gi, '').replace(/\(/gi, '').replace(/\)/gi, '').normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\?/gi, '').replace(/:/gi, '');
		}
	}
}
</script>
